<template>
	<div></div>
</template>
<script>
import { mapActions } from 'pinia'
import { useCraftsMasterStore } from '@/store/craftsMasterStore'

export default {
	created () {
		this.setErrorMessages(['Page not found'])
	},
	methods: {
		...mapActions(useCraftsMasterStore, ['setErrorMessages'])
	}
}
</script>
